/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphAreaIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Area',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M30.371 16.743 34 24v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V18l10 12 3.584-5.376a.5.5 0 0 1 .832 0L20 30l9.517-13.324a.5.5 0 0 1 .854.067Z"
    />
    <path
      d="m11.769 25.66 2.068-3.1.083-.124a2.5 2.5 0 0 1 4.16 0l.083.124 1.911 2.866 7.811-10.935.1-.135a2.5 2.5 0 0 1 4.271.335l.074.148L34 18.187V2l-8 10-5.609-5.609a.5.5 0 0 0-.74.037L7.8 20.9Z"
    />
  </svg>`;
};
